import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { tabs } from 'calcite-web';

@Component({
    selector: 'app-draw-tool',
    templateUrl: './draw-tool.component.html',
    styleUrls: ['./draw-tool.component.css']
})
export class DrawToolComponent implements OnInit {
    @ViewChild('map', { static: true }) private readonly mapRef: ElementRef<any>;
    @ViewChild('pointTab', { static: true }) private readonly pointTab: ElementRef<any>;
    @ViewChild('lineTab', { static: true }) private readonly lineTab: ElementRef<any>;
    @ViewChild('polygonTab', { static: true }) private readonly polygonTab: ElementRef<any>;
    @ViewChild('textTab', { static: true }) private readonly textTab: ElementRef<any>;
    @ViewChild('buffer', { static: true }) private readonly buffer: any;

    activeTab: ElementRef<any>;
    defaultSymbolProperties: any = {
        point: {
            type: 'simple-marker',
            style: 'circle',
            color: 'rgb(101, 135, 119)',
            size: '16px',
            outline: {
                color: 'black',
                width: 1
            }
        },
        line: {
            type: 'simple-line',
            style: 'solid',
            color: 'rgb(101, 135, 119)',
            width: 1,
            cap: 'round',
            join: 'round'
        },
        polygon: {
            type: 'simple-fill',
            color: 'rgb(101, 135, 119)',
            style: 'solid',
            outline: {
                color: 'black',
                style: 'solid',
                width: 1
            }
        },
        text: {
            type: 'text',
            color: 'black',
            horizontalAlignment: 'center',
            verticalAlignment: 'bottom',
            font: {
                size: '16px',
                family: 'Arial',
                weight: 'normal'
            }
        }
    };
    defaultToolType: string = 'point';
    initialized: boolean;
    tabs: any[] = [];

    constructor(private elementRef: ElementRef) { }

    ngOnInit() {
        tabs();
        this.initializeTabs();
    }

    initializeTabs() {
        for (const toolType of Object.keys(this.defaultSymbolProperties)) {
            this[toolType + 'Tab'].nativeElement.symbolProperties = this.defaultSymbolProperties[toolType];
        }
        this.initialized = true;
    }

    activateTabByName(toolType: string) {
        const tabName = toolType + 'Tab';
        if (this.activeTab) {
            this.activeTab.nativeElement.enabled = false;
        }
        this[tabName].nativeElement.enabled = true;
        this.activeTab = this[tabName];
    }

    open() {
        if (!this.initialized) {
            this.initializeTabs();
        }
        if (this.activeTab) {
            this.activeTab.nativeElement.enabled = true;
        } else {
            this.activateTabByName(this.defaultToolType);
            this.elementRef.nativeElement.querySelector('#' + this.defaultToolType + '-tab-title').classList.add('is-active');
        }
    }

    close() {
        if (this.activeTab && this.activeTab.nativeElement) {
            this.activeTab.nativeElement.enabled = false;
        }
    }

    onDrawComplete(event) {
    }
}
